<template>
  <!-- 撤销收款(应收租金、应收逾期费，应收违约金) -->
  <div class="revoke-receive-bd">
    <div class="info-container">
      <div class="l">
        <bill-container :title="$t('components_invoice_revoke_receive.zhang_dan_lie_biao')">
          <accounts-receivable-bill
            v-model="orderViewList"
            :auth="[]"
            :orderNum="registerMsg.billPaymentCode"
            tableCode="cancel_receive_bill"
          ></accounts-receivable-bill>
        </bill-container>
        <bill-container
          :title="$t('components_invoice_revoke_receive.zhi_fu_xin_xi')"
          v-if="tradeBoList && tradeBoList.length"
        >
          <collection-info-bill
            v-model="tradeBoList"
            :outerItem="firstOrderItem"
            :balance="registerMsg.balance"
            :billInfo="registerMsg"
            :auth="[]"
            :expandFlowMsg="true"
            tableCode="cancel_receive_pay_msg"
          ></collection-info-bill>
        </bill-container>
      </div>
      <div class="r">
        <div class="pay-info">
          <div class="title">{{ $t('components_invoice_revoke_receive.shou_kuan_xiang_qing') }}</div>
          <div class="order-code">
            <div class="label">{{ $t('components_invoice_revoke_receive.ding_dan_bian_hao') }}:</div>
            <div class="value">{{getPaymentCode(registerMsg)}}</div>
          </div>
          <!-- 收款时显示 -->
          <div class="order-code">
            <div class="label">{{ $t('components_invoice_revoke_receive.fu_kuan_fang') }}:</div>
            <div class="value">{{firstOrderItem.payableOrgName}}</div>
          </div>
          <div class="group-list">
            <div class="group">
              <div class="amount">
                <div class="should-pay"><span class="bold">{{ $t('components_invoice_revoke_receive.shi_fu_he_ji') }}：</span>￥{{actualPayAmount}}</div>
                <div class="details">
                  <div class="item">
                    <div class="key">{{ $t('components_invoice_revoke_receive.zu_lin_yu_e') }}</div>
                    <div class="val">￥{{expectUseRest}}</div>
                  </div>
                  <div class="item">
                    <div class="key">{{ $t('components_invoice_revoke_receive.dui_gong_zhuan_zhang') }}</div>
                    <div class="val">￥{{publicAmount}}</div>
                  </div>
                  <div class="item">
                    <div class="key">{{ $t('components_invoice_revoke_receive.xian_jin_zhi_fu') }}</div>
                    <div class="val">￥{{cashAmount}}</div>
                  </div>
                </div>
                <div class="should-pay expect-rest"><span class="bold">{{ $t('components_invoice_revoke_receive.ying_shou_he_ji') }}：</span>￥{{payableTotal}}</div>
                <div
                  class="should-pay"
                  v-if="thisRest"
                ><span class="bold">{{ $t('components_invoice_revoke_receive.ben_ci_jie_yu') }}：</span>￥{{thisRest}}</div>
                <div class="should-pay mt-15">{{ $t('components_invoice_revoke_receive.fu_kuan_cao_zuo_ren') }}：{{paymentConfirmUser || '-'}}</div>
                <div class="should-pay">{{ $t('components_invoice_revoke_receive.fkczsj') }}：{{paymentConfirmTime || '-'}}</div>
              </div>
            </div>
            <div class="group">
              <div class="amount">
                <div class="should-pay"><span class="bold">{{ $t('components_invoice_revoke_receive.yqrsk') }}：</span>￥{{total}}</div>
                <div class="should-pay"><span class="bold">{{ $t('components_invoice_revoke_receive.yi_que_ren_shou_kuan') }}：</span>￥{{confirmTotal}}</div>
                <div class="should-pay mt-15">{{ $t('components_invoice_revoke_receive.skczr') }}：{{receiveConfirmUser || '-' }}</div>
                <div class="should-pay">{{ $t('components_invoice_revoke_receive.skczsj') }}：{{$momentLocal(receiveConfirmTime) || '-' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 退款信息 -->
    <bill-container
      :title="$t('components_invoice_revoke_receive.che_xiao_xiang_qing')"
      class="refund-msg"
    >
      <div class="finance-base-bill">
        <div class="header">
          <div class="bill-base-msg">
            <i class="icon icon-tishi"></i>
            <div class="order-num">
              {{ $t('components_invoice_revoke_receive.zhu') }}：{{ $t('components_invoice_revoke_receive.sptghxtjhhtzbddzfzt') }}，{{ $t('components_invoice_revoke_receive.zdztbgw') }}“{{ $t('components_invoice_revoke_receive.wei_jiao_yi') }}”，{{ $t('components_invoice_revoke_receive.yzfjethdfkfzlye') }}
            </div>
          </div>
        </div>
        <el-row
          style="padding-top: 16px"
          class="item-title-info"
        >
          <el-col :span="24">
            <span class="label">{{ $t('components_invoice_revoke_receive.cxskhxthjcthdodzlyez', [ billPayment.totalPaymentAmount , billPayment.payableOrgName ]) }}</span>
          </el-col>
        </el-row>
      </div>
    </bill-container>
    <div
      class="item-title"
      style="margin-top: 15px"
    >{{ $t('components_invoice_revoke_receive.che_xiao_yuan_yin') }}</div>
    <el-form
      :model="form"
      ref="form"
      label-width="auto"
      :rules="rules"
    >
      <el-form-item prop="changeDesc">
        <el-input
          type="textarea"
          :rows="4"
          :placeholder="$t('components_invoice_revoke_receive.qsrcxyy')"
          :disabled="model.type === 'watch'"
          v-model="form.changeDesc"
          style="width: 100%"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import apis from '@/utils/apis';
// import customTab from '@/components/customTab.vue';
import billContainer from '@/pages/fms/components/bill_container';
import accountsReceivableBill from '@/pages/fms/components/accounts_registration_accounts_bill';
import collectionInfoBill from '@/pages/fms/components/accounts_registration_msg_bill';

export default {
  // mixins: [languageInjectMixins],
  components: { accountsReceivableBill, collectionInfoBill, billContainer },
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '',
          row: {} // 非必传，新增用
        };
      }
    }
  },
  data() {
    return {
      useRest: false,
      billPayment: {},
      orderViewList: [],
      tradeBoList: [],
      tradeSellerBos: [],
      registerMsg: {
        balance: 0,
        deposit: 0,
        billPaymentCode: ''
      },
      partnerBalance: {},
      form: {
        billType: '',
        billId: '',
        changeDesc: '',
        changeId: ''
      },
      paymentOrReceivable: false,
      firstOrderItem: {}
    };
  },
  computed: {
    rules() {
      return {
        changeDesc: [{ required: true, message: this.$t('Common.com_required') }, { max: 100, message: this.$t('Common.com_rules_length_max', [100]), }]
      };
    },
    balance() {
      // return this.registerMsg.balance;
      return this.getTradeBalance(this.registerMsg);
    },
    // 本次结余 实付金额-应付金额，若本次结余为0时不显示此行）
    thisRest() {
      const actualPayAmount = this.actualPayAmount || 0;
      const payableTotal = this.payableTotal || 0;
      return Math.max(actualPayAmount - payableTotal, 0);
    },
    // 现金支付
    cashAmount() {
      const list = this.tradeBoList;
      if (this.dicMap.payment_class) {
        const ret = list.filter(item => `${item.tradeMethod}` === `${this.dicMap.payment_class.cash}`);
        return ret.reduce((total, item) => {
          const { totalAmount = 0 } = item;
          return total + Number(totalAmount);
        }, 0);
      }
      return 0;
    },
    // 操作人
    receiveConfirmUser() {
      let billPayment = {};
      if (this.registerMsg && this.registerMsg.billPayment) {
        billPayment = this.registerMsg.billPayment;
      }
      return billPayment.receiveConfirmUser;
    },
    // 操作时间
    receiveConfirmTime() {
      let billPayment = {};
      if (this.registerMsg && this.registerMsg.billPayment) {
        billPayment = this.registerMsg.billPayment;
      }
      return billPayment.receiveConfirmTime;
    },
    // 实付金额
    actualPayAmount() {
      const expectUseRest = this.expectUseRest || 0;
      const total = this.total || 0;
      return expectUseRest + total;
    },
    // 操作人: paymentConfirmUser
    paymentConfirmUser() {
      let billPayment = {};
      if (this.registerMsg && this.registerMsg.billPayment) {
        billPayment = this.registerMsg.billPayment;
      }
      return billPayment.paymentConfirmUser;
    },
    // 操作时间：paymentConfirmTime
    paymentConfirmTime() {
      let billPayment = {};
      if (this.registerMsg && this.registerMsg.billPayment) {
        billPayment = this.registerMsg.billPayment;
      }
      return this.$momentLocal(billPayment.paymentConfirmTime);
    },
    // 支付金额总和
    total() {
      const key = 'totalAmount';
      const list = this.tradeBoList;
      return list.reduce((total, item) => total + Number(item[key] || 0), 0);
    },
    // 已确认收款
    confirmTotal() {
      const key = 'totalAmount';
      const list = this.tradeBoList.filter(item => item.sellerTradeCode);
      return list.reduce((total, item) => total + Number(item[key] || 0), 0);
    },
    payableTotal() {
      return this.orderViewList.reduce((total, item) => {
        const { paymentAmount = 0 } = item;
        const sum = paymentAmount;
        return sum + total;
      }, 0);
    },
    // 预计使用余额
    expectUseRest() {
      // const accountTotal = this.payableTotal || 0;
      // // 是否使用余额
      // const useRest = this.useRest;
      // // 现有余额
      // const balance = this.balance || 0;
      // if (!useRest) {
      //   return 0;
      // } else {
      //   if (balance >= accountTotal) {
      //     return accountTotal;
      //   } else {
      //     return balance;
      //   }
      // }
      const payableTotal = this.payableTotal || 0;
      const tradeTotal = this.total || 0;
      const balance = this.useRest ? this.balance || 0 : 0;
      const ret = payableTotal - tradeTotal >= balance ? balance : payableTotal - tradeTotal;
      return Math.max(ret, 0);
    },
    // 对公转账
    publicAmount() {
      const list = this.tradeBoList;
      if (this.dicMap.payment_class) {
        const ret = list.filter(item => `${item.tradeMethod}` === `${this.dicMap.payment_class.public_account}`);
        return ret.reduce((total, item) => {
          const { totalAmount = 0 } = item;
          return total + Number(totalAmount);
        }, 0);
      }
      return 0;
    },

  },
  mounted() {
    this.getDicMap('payment_class');
    if (!this.model.changeId && !this.model.row.billId && this.model.row.paymentId) {
      this.getDetailByPaymentId(this.model.row.paymentId);
    } else {
      this.getDetail();
    }
  },
  methods: {
    // 获取详情 - 通过paymentId
    getDetailByPaymentId(paymentId) {
      if (this.model.row) {
        this.firstOrderItem = this.model.row;
      }
      this.$getJSON(apis.fmsWithdrawInfoByPaymentId, { paymentId }).then((res) => {
        const data = res.data.paymentInfo;
        if (!data.orderViewList || !data.orderViewList.length) {
          this.$message.error(this.$t('components_invoice_revoke_receive.fhxqsjyc'));
          return;
        }
        const orderViewList = data.orderViewList;
        const billItem = orderViewList[0];
        this.form.changeDesc = res.data.changeDesc;
        // 新增的话，没有changeId，传入null
        this.form.changeId = res.data.changeId || null;
        this.form.billType = res.data.billType || billItem.billType || '';
        // 如果有changeId, billId为null; 如果没有changeId，billId不能为空
        this.form.billId = res.data.changeId ? null : billItem.billId;
        this.registerMsg = data;
        this.registerMsg.billPaymentCode = data.billPaymentCode;
        this.registerMsg.balance = this.getBalance(data);
        this.registerMsg.deposit = data.deposit || 0;
        // this.balance = this.registerMsg.balance;
        if (data.billPayment) {
          this.useRest = data.billPayment.isUseBalance;
        }
        // 支付信息
        this.billPayment = data.billPayment;
        // 应退押金明细
        if (data.orderViewList && data.orderViewList.length) {
          this.orderViewList = data.orderViewList;
          this.firstOrderItem = this.orderViewList[0];
        }
        // 收款登记
        if (data.tradeBoList && data.tradeBoList.length) {
          data.tradeBoList.forEach((item) => {
            item.attachs = [];
            this.$getJSON(`${apis.OssAttach}/${item.tradeId}/fms.trade.certificate`).then((imgRes) => {
              item.attachs = imgRes.data;
            });
          });
          this.tradeBoList = data.tradeBoList;
        }
        // 银行流水
        if (data.tradeSellerBos && data.tradeSellerBos.length) {
          this.tradeSellerBos = data.tradeSellerBos;
        }
        // 余额信息
        this.partnerBalance = data.partnerBalance || {};
      });
    },
    // 获取编辑详情
    getDetail: function () {
      if (this.model.row) {
        this.firstOrderItem = this.model.row;
      }
      // this.model.changeId 存在就是编辑，否则是新增
      this.$getJSON(`${apis.fmsWithdrawInfo}/${this.model.changeId || this.model.row.billId}`).then((res) => {
        const isEdit = !!this.model.changeId;
        this.form.changeDesc = res.data.changeDesc;
        this.form.changeId = isEdit ? res.data.changeId : null;
        this.form.billType = res.data.billType || '';
        this.form.billId = isEdit ? null : this.model.row.billId;
        const data = res.data.paymentInfo;
        this.registerMsg = data;
        this.registerMsg.billPaymentCode = data.billPaymentCode;
        this.registerMsg.balance = this.getBalance(data);
        this.registerMsg.deposit = data.deposit || 0;
        // this.balance = this.registerMsg.balance;
        if (data.billPayment) {
          this.useRest = data.billPayment.isUseBalance;
        }
        // 支付信息
        this.billPayment = data.billPayment;
        // 应退押金明细
        if (data.orderViewList && data.orderViewList.length) {
          this.orderViewList = data.orderViewList;
          this.firstOrderItem = this.orderViewList[0];
        }
        // 收款登记
        if (data.tradeBoList && data.tradeBoList.length) {
          data.tradeBoList.forEach((item) => {
            item.attachs = [];
            this.$getJSON(`${apis.OssAttach}/${item.tradeId}/fms.trade.certificate`).then((imgRes) => {
              item.attachs = imgRes.data;
            });
          });
          this.tradeBoList = data.tradeBoList;
        }
        // 银行流水
        if (data.tradeSellerBos && data.tradeSellerBos.length) {
          this.tradeSellerBos = data.tradeSellerBos;
        }
        // 余额信息
        this.partnerBalance = data.partnerBalance || {};
      });
      // }
    },
    // 确认保存
    onConfirm: function (approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(apis.fmsWithdrawDraft, this.form).then((res) => {
          if (approve) {
            this.onSubmit(res.data);
            return;
          }
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success'
          });
          this.$emit('success', this.form);
        });
      });
    },
    // 提交审批
    onSubmit(row) {
      this.$postJSON(
        `${apis.apsApproveApprovalApproveStart}/withdrawal_payment/${row.changeId}`,
        {
          title: [`【${row.changeId}】`, this.getDicValue('approval_type', 'withdrawal_payment')].join(' '),
          applyReason: row.changeDesc
        },
        true
      ).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success')
        });
        this.$emit('success', this.form);
      });
    }
  }
};
</script>

<style lang="scss">
.revoke-receive-bd {
  .refund-msg {
    margin-top: 15px;
  }
  .bold {
    font-weight: bold;
  }
  .mt-15 {
    margin-top: 15px;
  }
  .order-num {
    max-width: none !important;
  }
  .red-font {
    color: #ff5c5b;
  }

  .expect-rest {
    margin-top: 24px;
  }
  .info-container {
    display: flex;
    .l {
      flex: 1;
      padding-right: 20px;
      overflow: hidden;
    }

    .r {
      width: 350px;

      .pay-info {
        .item {
          overflow: hidden;
          &:nth-child(n + 2) {
            margin-top: 4px;
          }
          .key {
            float: left;
            font-size: 12px;
            color: #4d4d4d;
            line-height: 18px;
          }
          .val {
            overflow: hidden;
            font-size: 12px;
            color: #1a1a1a;
            line-height: 18px;
            padding-left: 16px;
            white-space: normal;
          }
        }
      }

      .pay-info {
        background: #fff;
        padding: 10px;
        border: 1px solid whitesmoke;
        border-radius: 4px;
        overflow: hidden;
        border-top: 4px solid #00a0d9;

        > .title {
          line-height: 30px;
          font-size: 14px;
          margin-bottom: 10px;
          font-weight: bold;
        }

        .order-code {
          color: #4d4d4d;
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 10px;
          overflow: hidden;

          .label {
            float: left;
          }
          .value {
            overflow: hidden;
            padding-left: 16px;
          }
        }

        .group {
          padding: 24px 0;
          border-top: 1px solid rgba(245, 245, 245, 1);

          // &:last-child {
          //   border-bottom: 1px solid rgba(245, 245, 245, 1);
          // }
        }

        .rest {
          overflow: hidden;
          line-height: 20px;
          .label {
            font-size: 14px;
            float: left;
            color: #4d4d4d;
          }
          .value {
            float: left;
            font-size: 14px;
            color: #1a1a1a;
            padding-left: 16px;
          }
          .use-rest {
            float: right;
            .use-label {
              float: left;
              color: #4d4d4d;
            }
            .use-cb {
              float: left;
              margin-left: 10px;
            }
          }
        }

        .amount {
          .should-pay {
            line-height: 24px;
            color: #4d4d4d;
            font-size: 14px;
          }

          .details {
            background: rgba(248, 249, 250, 1);
            padding: 16px;
            margin-top: 16px;
            .item {
              line-height: 20px;
              font-size: 14px;
              overflow: hidden;
              &:nth-child(n + 2) {
                margin-top: 12px;
              }
              .key {
                color: #4d4d4d;
                float: left;
              }
              .val {
                color: #1a1a1a;
                float: right;
              }
            }
          }

          .actual-pay {
            overflow: hidden;
            line-height: 24px;
            font-size: 14px;
            margin-top: 20px;
            .key {
              float: left;
              color: #1a1a1a;
            }
            .val {
              float: left;
              color: #00a0d9;
            }
          }
        }

        .btn-content {
          padding-top: 24px;
          padding-bottom: 10px;

          .btn {
            display: block;
            width: 100%;
            margin-left: 0 !important;
            &:nth-child(n + 2) {
              margin-top: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
